import yohana from '@assets/images/w-yohana.jpg';
import isma from './assets/w-isma.jpg';
import bulan from './assets/w-bulan.jpg';
import erni from './assets/w-erni.jpg';
import megga from './assets/w-megga.jpg';
import terry from './assets/w-terry.jpg';
import fatchur from './assets/w-fatchur.jpg';
import erwin from './assets/w-erwin.jpg';
import murni from './assets/w-murni.jpg';
import kurnia from './assets/w-kurnia.jpg';
import mugik from './assets/w-mugik.jpg';
import anang from './assets/w-anang.jpg';
import candra from './assets/w-candra.jpg';
import iruka from './assets/w-iruka.jpg';
import imam from './assets/w-imam.jpg';
import roro from './assets/w-roro.jpg';
import puspa from './assets/w-puspa.jpg';
import purwanti from './assets/w-purwanti.jpg';
import yani from './assets/w-yani.jpg';
import rudi from './assets/w-rudi.jpg';


export const wishlist = [
  {
    name: 'Yohana Asmara Dewi',
    infoName: 'Rekan Kerja Mei, PT Catur Adhi Manunggal',
    description: `"Mulanya Allah SWT menciptakan satu jiwa, kemudian Ia membelahnya menjadi dua. 
    Sehingga Allah yang maha pengasih lagi maha penyayang bisa kembali menyatukan kalian dalam ikatan suci pernikahan. 
    Semoga pernikahan kalian ini menjadi pernikahan yg abadi dan bisa membawa kebahagiaan bagi orang-orang sekitar. 
    Dan juga semoga Allah selalu memberikan rahmat Nya pada kalian untuk dapat merasakan kebahagiaan dan kedamaian, aamiin. 
    Selamat menempuh hidup baru Faisal dan Mei."`,
    image: yohana,
  },
    {
    name: 'Isma Oktaviana',
    infoName: 'Rekan Kerja Mei, PT Flying Eagle',
    description: `"Selamat hari bahagia. Jadikanlah pernikahan ini sebagai ibadah sepanjang hidupmu. 
    Semoga Allah SWT selalu memberi kemudahan dalam perjalanan cinta kalian. Semoga kalian dianugerahi keturunan yang soleh dan sholehah."`,
    image: isma,
  },
  {
    name: 'Rembulan Adiluhur AF',
    infoName: 'Sahabat Kuliah Mei',
    description: `"Selamat menikah, Sahabatku 🤍.
    Saat ini engkau telah menempuh kehidupan baru dengan pendamping hidup yang telah Allah pilih untukmu. 
    Semoga rahmat dan kasih sayang Allah selalu menyertai kalian, selalu jadi pribadi yang baik, 
    selalu bersyukur dan semoga pintu rezeki selalu terbuka dengan lancar. Aamiin YRA."`,
    image: bulan,
  },
  {
    name: 'Erni Safitri',
    infoName: 'Sahabat SMP - Kuliah Mei',
    description: `"Dear Mei dan Faisal.
    Selamat menempuh hidup baru, perjalanan baru dan panjang akan segera dimulai, 
    semoga Allah limpahkan berkah dan kasih sayang untuk rumah tangga kalian berdua. Aamiin."`,
    image: erni,
  },
  {
    name: 'Megga Agra Dwinda',
    infoName: 'Sahabat SMP - SMA Mei',
    description: `"Happy Wedding to a wonderful couple Mei & Faisal.
    Selamat menempuh kehidupan bahtera rumah tangga sahabatku, semoga selalu menjadi pasangan yang saling mengasihi satu sama lain dalam ikatan utuh till jannah. 
    May love always all arround you forever aamiin."`,
    image: megga,
  },
  {
    name: 'Terry Mirnawati',
    infoName: 'Sahabat Kecil Mei',
    description: `"Selamat menempuh hidup baru mbak Mei dan mas Faisal 🖤
    Semoga menjadi keluarga yang saqinah mawaddah serta warrohmah,
    Mendapatkan keturunan yg Sholeh dan sholehah,
    Diberikan rejeki yg berkah,
    Selalu didalam lindungan serta kasih sayang Allah SWT."`,
    image: terry,
  },
  {
    name: 'Fatchur Rohman',
    infoName: 'Sahabat SMA Mei',
    description: `"Selamat Menempuh Hidup Baru Mei dan Faisal.
    Semoga menjadi keluarga sakinah, mawaddah, warrahmah dan langgeng sampai nenek" kakek". Aamiin 🤲🏻. 
    ~ Fatchur-Dita-Zavier ~"`,
    image: fatchur,
  },
  {
    name: 'Erwin Nurhadi',
    infoName: 'Rekan Kerja Mei, PT Flying Eagle',
    description: `"Pernikahan merupakah awal baru dalam kehidupan, awal dari sebuah kebersamaan dan kebahagiaan.
    Selamat atas pernikahan kalian berdua Mei & Faisal,
    Selamat berbahagia sahabatku atas pernikahanmu, semoga ridho Allah SWT senantiasa menyertai kalian berdua. 
    Semoga Sakinah, Mawaddah, Warohmah. Aaamiin"`,
    image: erwin,
  },
  {
    name: 'Murni Setyowati',
    infoName: 'Rekan Kerja Mei, PT Catur Adhi Manunggal',
    description: `Selamat menikah untuk Sahabatku Mbak Mei & Mas Faisal, Baik-baik ya karena kamu sekarang akan mengemban amanah sebagai istri yang harus taat pada suamimu. Kamu harus rela dan ikhlas karena ridha Allah juga terletak pada ridha suamimu. Dan semoga menjadi keluarga Sakinah ,Mawadah & Warrahmah. Aamiin`,
    image: murni,
  },
  {
    name: 'Kurnia Mahardhika K & Istri',
    infoName: 'Sahabat SMA Mei',
    description: `Selamat menempuh hidup baru untuk Mei dan Faisal, sejatinya pernikahan adalah lembaran baru kehidupan, kebahagiaan, kebersamaan, dan hal-hal baik lainnya yang menyertai. Semoga cinta kalian terus bertumbuh dan semakin menguat setiap harinya. Dan Allah SWT menjadikan kalian menjadi keluarga yang Sakinah, Mawaddah, Warahmah. Aamiin Aamiin Ya Rabbal Alaamiin`,
    image: kurnia,
  },
  {
    name: 'Mugiyono',
    infoName: 'Sahabat SMA Mei',
    description: `Selamat buat Mei dan Faisal, semoga diberi kesehatan yang lebih baik, rejeki yang lebih baik, dan jangan lupa kabar kabar kalo sudah diberi momongan baru ☺️`,
    image: mugik,
  },
  {
    name: 'Anang Satrio Nugroho',
    infoName: 'Sahabat SMA Mei',
    description: `Selamat menempuh hidup baru Mei, semoga menjadi keluarga yang sakinah, mawadah warohmah, dilimpahkan rezeki nya dan selalu memberikan kebahagiaan bagi keluarga dan orang orang sekitar aamiin`,
    image: anang,
  },
  {
    name: 'Candra Dwi Prasetyo',
    infoName: 'Sahabat SMA Mei',
    description: `Happy wedding ya Mei dan Faisal. Barakallahu lakuma wa baraka a'laikuma wa jama'a bainakuma fii khoir`,
    image: candra,
  },
  {
    name: 'Solekhah Nur Hayati Widodo',
    infoName: 'Sahabat Teater Faisal',
    description: `"Turut berbahagia, Semoga cita-cita berdua segera terwujud.
    Semoga diberkahi, diberi kekuatan serta kebahagiaan selalu untuk keluarga barunya dan menjadi tabungan surga.
    Selamat menempuh hidup baru..."`,
    image: iruka,
  },
  {
    name: 'Imam Mahfudz',
    infoName: 'Sahabat Teater Faisal',
    description: `"Selamat memasuki fase hidup baru. Berkah, bahagia, dan lhaass lheess~"`,
    image: imam,
  },
  {
    name: 'Diajeng roro',
    infoName: 'Sahabat Teater Faisal',
    description: `"Happy wedding dek ical dan Mei ...Lembaran baru dimulai, tantangan dan rintangan pastinya selalu menyertai,
    ingat hari ini,dimana kamu mengucap kalimat sakral di altar Tuhan ketika kamu di puncak menyerah dari segala masalah. 
    Doaku semoga kalian selalu disertai kebahagiaan dan keberkahan dalam mengarungi bahtera rumah tangga, 
    Sakinah, Mawaddah dan Warohmah, aaamiin"`,
    image: roro,
  },
  {
    name: 'Dyah puspa & Keluarga',
    infoName: 'Saudara Faisal',
    description: `"Selamat atas pernikahan om Sal n onty Mei.
    Selamat mengarungi bahtera rumah tangga, semangat untuk bekerja sama dalam suka dan duka. 
    Semoga Allah SWT berikan perlindungan, kesehatan, dan kelimpahan rezeki yang barokah. 
    Sakinah, Mawaddah, wa Rahmah. Aamiin"`,
    image: puspa,
  },
  {
    name: 'Purwanti & Keluarga',
    infoName: 'Saudara Faisal',
    description: `"Doa terbaik kagem panjenengan sedoyo.. Mugi2 tansah pinaringan kesarasan,umur lan rizki ingkang berkah barokah.
    diparingi kelancaran kagem acaranipun om sal kalian nte mei, pangapurane mboten saged biantu nopo2 naming saged urun dungo saking mriki....
    Mugi2 Allah ijabahi. Aamiin."`,
    image: purwanti,
  },
  {
    name: 'Urip Tri Handayani',
    infoName: 'Rekan Kerja Faisal, PT Toko Besi Tan',
    description: `Selamat hari bahagia. Jadikanlah pernikahan ini sebagai ibadah sepanjang hidupmu. Semoga Allah SWT selalu memberi kemudahan dalam perjalanan cinta kalian dan menjadikan kalian pribadi yang semakin taqwa untuk menggapai ridho-Nya.`,
    image: yani,
  },
  {
    name: 'Ahmad Rudi Irawan',
    infoName: 'Sahabat kuliah Faisal',
    description: `Selamat menempuh hidup baru untuk mas Faisal dan mba Mei, barakallahu lakum wa baraka alaikum. semoga jadi keluarga yang sakinah, mawaddah dan warahmah 🤲`,
    image: rudi,
  },
];
